(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('jh-header')) return;

    class JhHeader extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.shopify-section') || this.parentElement;
        this.bar = this.querySelector('.jh__bar');
        this.panels = {};
        this.querySelectorAll('.jh__panel').forEach((p) => (this.panels[p.dataset.panel] = p));
        this.triggers = Array.prototype.slice.call(this.querySelectorAll('[data-panel-target]'));
        this.burger = this.querySelector('.jh__burger');
        this.searchInput = this.querySelector('.jh__search-input');
        this.searchResults = this.querySelector('[data-search-results]');

        this.openDelay = this.num('openDelay', 60);
        this.closeDelay = this.num('closeDelay', 160);
        this.l2Delay = this.num('l2Delay', 100);
        this.speed = this.num('speed', 250);

        this.desktop = window.matchMedia('(min-width: 990px)');
        this.coarse = window.matchMedia('(hover: none)');
        this.current = null;

        this.bindTriggers();
        this.bindPanels();
        this.bindGlobal();
        this.bindDrawer();
        this.bindSearch();
        this.bindCart();
        this.bindSticky();
      }

      disconnectedCallback() {
        this.cleanups && this.cleanups.forEach((fn) => fn());
        this.cleanups = [];
        if (this.wrapper) this.wrapper.classList.remove('jh-sticky', 'jh-hidden');
        document.body.classList.remove('jh-no-scroll');
      }

      num(name, fallback) {
        const raw = this.dataset[name];
        const v = Number(raw);
        return raw !== undefined && raw !== '' && isFinite(v) ? v : fallback;
      }

      on(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        (this.cleanups = this.cleanups || []).push(() => target.removeEventListener(type, fn, opts));
      }

      /* ---------- panels ---------- */
      show(key) {
        const panel = this.panels[key];
        if (!panel) return;
        clearTimeout(this.openT);
        clearTimeout(this.closeT);
        if (this.current === key) return;
        if (this.current) this.deactivate(this.current);
        this.current = key;
        clearTimeout(panel._hideT);
        panel.classList.add('is-shown');
        void panel.offsetWidth;
        panel.classList.add('is-open');
        if (key !== 'search') this.setActive(panel, 0);
        this.classList.add('is-open');
        this.syncTriggers(key);
        if (key === 'search' && this.searchInput) setTimeout(() => this.searchInput.focus(), 60);
      }

      deactivate(key) {
        const panel = this.panels[key];
        if (!panel) return;
        panel.classList.remove('is-open');
        panel._hideT = setTimeout(() => panel.classList.remove('is-shown'), this.speed);
      }

      hide() {
        clearTimeout(this.openT);
        clearTimeout(this.closeT);
        if (!this.current) return;
        this.deactivate(this.current);
        this.current = null;
        this.classList.remove('is-open');
        this.syncTriggers(null);
      }

      syncTriggers(key) {
        this.triggers.forEach((t) => {
          const on = key !== null && t.dataset.panelTarget === key;
          t.classList.toggle('is-active', on);
          if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }

      scheduleShow(key) {
        clearTimeout(this.closeT);
        clearTimeout(this.openT);
        this.openT = setTimeout(() => this.show(key), this.current ? 0 : this.openDelay);
      }

      scheduleHide() {
        clearTimeout(this.openT);
        clearTimeout(this.closeT);
        this.closeT = setTimeout(() => this.hide(), this.closeDelay);
      }

      setActive(panel, index) {
        panel.querySelectorAll('[data-index]').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.index === String(index));
        });
      }

      hoverOK() {
        return this.desktop.matches && !this.coarse.matches;
      }

      bindTriggers() {
        this.triggers.forEach((t) => {
          const key = t.dataset.panelTarget;
          if (key === 'search') {
            this.on(t, 'click', (e) => {
              e.preventDefault();
              this.current === 'search' ? this.hide() : this.show('search');
            });
            return;
          }
          this.on(t, 'mouseenter', () => {
            if (this.hoverOK()) this.scheduleShow(key);
          });
          this.on(t, 'mouseleave', () => clearTimeout(this.openT));
          this.on(t, 'focus', () => {
            if (this.desktop.matches && !t.matches(':hover')) this.show(key);
          });
          this.on(t, 'click', (e) => {
            if (this.desktop.matches && this.coarse.matches && this.current !== key) {
              e.preventDefault();
              this.show(key);
            }
          });
        });
      }

      bindPanels() {
        Object.keys(this.panels).forEach((key) => {
          if (key === 'search') return;
          const panel = this.panels[key];
          panel.querySelectorAll('.jh__lvl2-item').forEach((li) => {
            const idx = li.dataset.index;
            this.on(li, 'mouseenter', () => {
              clearTimeout(panel._t);
              panel._t = setTimeout(() => this.setActive(panel, idx), this.l2Delay);
            });
            this.on(li, 'mouseleave', () => clearTimeout(panel._t));
            this.on(li, 'focusin', () => this.setActive(panel, idx));
          });
        });
      }

      bindGlobal() {
        // Moving over the bar but not over a mega trigger closes mega panels (not search).
        this.on(this.bar, 'mouseover', (e) => {
          if (!this.hoverOK()) return;
          if (e.target.closest('[data-panel-target]')) return;
          if (this.current && this.current !== 'search') this.scheduleHide();
        });
        // Inside a panel: cancel any pending close.
        this.on(this, 'mouseover', (e) => {
          if (!e.target.closest('.jh__bar')) clearTimeout(this.closeT);
        });
        this.on(this, 'mouseleave', () => {
          if (this.hoverOK() && this.current && this.current !== 'search') this.scheduleHide();
        });
        this.on(this, 'focusout', (e) => {
          if (!this.contains(e.relatedTarget) && this.current && this.current !== 'search') this.hide();
        });
        this.on(document, 'click', (e) => {
          if (this.current && !this.contains(e.target)) this.hide();
        });
        this.on(document, 'keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (this.classList.contains('is-drawer-open')) {
            this.toggleDrawer(false);
            this.burger && this.burger.focus();
          }
          if (this.current) {
            const wasSearch = this.current === 'search';
            this.hide();
            if (wasSearch) {
              const s = this.querySelector('.jh__util--search');
              s && s.focus();
            }
          }
        });

        // Theme editor: open the mega panel when its "Mega menu images" block is selected.
        this.on(document, 'shopify:block:select', (e) => {
          const id = e.detail && e.detail.blockId;
          const panel = id && this.querySelector('.jh__panel[data-block-id="' + id + '"]');
          if (panel && this.desktop.matches) this.show(panel.dataset.panel);
        });
        this.on(document, 'shopify:block:deselect', () => this.hide());
      }

      /* ---------- mobile drawer ---------- */
      toggleDrawer(force) {
        const open = typeof force === 'boolean' ? force : !this.classList.contains('is-drawer-open');
        if (open) {
          this.hide();
          this.wrapper && this.wrapper.classList.remove('jh-hidden');
          this.style.setProperty('--jh-drawer-top', Math.max(0, Math.round(this.bar.getBoundingClientRect().bottom)) + 'px');
        }
        this.classList.toggle('is-drawer-open', open);
        this.burger && this.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('jh-no-scroll', open);
      }

      bindDrawer() {
        if (!this.burger) return;
        this.on(this.burger, 'click', () => this.toggleDrawer());
        this.on(this.desktop, 'change', () => this.toggleDrawer(false));
      }

      /* ---------- search ---------- */
      bindSearch() {
        if (!this.searchInput) return;
        this.on(this.searchInput, 'input', () => {
          clearTimeout(this.searchT);
          this.searchT = setTimeout(() => this.suggest(this.searchInput.value.trim()), 250);
        });
        this.querySelectorAll('[data-search-close]').forEach((b) => this.on(b, 'click', () => this.hide()));
      }

      esc(str) {
        const d = document.createElement('div');
        d.textContent = str == null ? '' : String(str);
        return d.innerHTML.replace(/"/g, '&quot;');
      }

      async suggest(q) {
        const box = this.searchResults;
        if (!box) return;
        if (q.length < 2) {
          box.innerHTML = '';
          return;
        }
        if (this.searchAbort) this.searchAbort.abort();
        this.searchAbort = new AbortController();
        try {
          const url =
            this.dataset.suggestUrl +
            '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: this.searchAbort.signal });
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          const allUrl = this.dataset.searchUrl + '?q=' + encodeURIComponent(q);
          if (!products.length) {
            box.innerHTML = '<span class="jh__sr-none">' + this.esc(this.dataset.noResults) + '</span>';
            return;
          }
          box.innerHTML =
            '<div class="jh__sr-grid">' +
            products
              .map(
                (p) =>
                  '<a class="jh__sr-item" href="' + this.esc(p.url) + '">' +
                  (p.image ? '<img src="' + this.esc(p.image) + '" alt="" loading="lazy">' : '') +
                  '<span class="jh__sr-title">' + this.esc(p.title) + '</span></a>'
              )
              .join('') +
            '</div><a class="jh__sr-all" href="' + this.esc(allUrl) + '">' + this.esc(this.dataset.allResults) + '</a>';
        } catch (err) {
          if (err.name !== 'AbortError') box.innerHTML = '';
        }
      }

      /* ---------- cart ---------- */
      setCount(n) {
        this.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = n > 0 ? '(' + n + ')' : '';
          el.hidden = !(n > 0);
        });
      }

      bindCart() {
        const bags = this.querySelectorAll('.jh__bag');
        if (this.dataset.cartType === 'drawer') {
          bags.forEach((b) =>
            this.on(b, 'click', (e) => {
              const d = document.querySelector('cart-drawer');
              if (d && typeof d.open === 'function') {
                e.preventDefault();
                d.open(b);
              }
            })
          );
        }
        this.refreshCart = () =>
          fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((c) => this.setCount(c.item_count))
            .catch(() => {});
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refreshCart);
          if (typeof unsub === 'function') (this.cleanups = this.cleanups || []).push(unsub);
        }
        this.on(window, 'pageshow', (e) => e.persisted && this.refreshCart());
      }

      /* ---------- sticky ---------- */
      bindSticky() {
        const wrap = this.wrapper;
        if (!wrap) return;
        const setH = () => document.documentElement.style.setProperty('--header-height', wrap.offsetHeight + 'px');
        setH();
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(setH);
          ro.observe(wrap);
          (this.cleanups = this.cleanups || []).push(() => ro.disconnect());
        }

        const type = this.dataset.sticky;
        if (type === 'none') return;
        wrap.classList.add('jh-sticky');
        if (type !== 'on-scroll-up') return;

        let last = window.scrollY;
        this.on(
          window,
          'scroll',
          () => {
            const y = Math.max(0, window.scrollY);
            if (this.current || this.classList.contains('is-drawer-open')) {
              last = y;
              return;
            }
            if (y > last && y > wrap.offsetHeight) wrap.classList.add('jh-hidden');
            else if (y < last) wrap.classList.remove('jh-hidden');
            last = y;
          },
          { passive: true }
        );
      }
    }

    customElements.define('jh-header', JhHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
